import React, { FC, useCallback, useEffect, useState } from 'react';
import { buildOpeningOrderFlowLink } from 'utils/offersTableConfigs';
import { AuthorizedProductCardsProps } from './types';
import { ProductCardsContent } from '../ProductCardsContent';

const AuthorizedProductCards: FC<AuthorizedProductCardsProps> = (props) => {
  const { productIds, dbs, locale } = props;
  const [linkDictionary, setLinkDictionary] = useState<Record<string, string>>({});
  const onLinkGenerate = useCallback(
    (productId: string) => linkDictionary[productId] ?? '',
    [linkDictionary],
  );

  useEffect(() => {
    const getLinks = async () => {
      const links = await Promise.all(
        productIds.map(async (id) => ({
          link: await buildOpeningOrderFlowLink(locale, dbs[id]),
          id,
        })),
      );
      setLinkDictionary(
        links.reduce((pre, { id, link }) => ({ ...pre, [id]: link }), {} as Record<string, string>),
      );
    };

    // eslint-disable-next-line no-console
    getLinks().catch(console.error);
  }, [productIds, locale, dbs]);

  return <ProductCardsContent testId="Authorized" {...props} linkGenerator={onLinkGenerate} />;
};
export default AuthorizedProductCards;
